// @ts-nocheck
import { deleteDTB, removeDTBLock, takeDTBLock } from '../Library/_data_sources/manageDTB';
import { getDTBs } from '../Library/_data_sources/useDTBs';

declare global {
  interface Window {
    cleanDTBs: (dtbIds?: string[]) => Promise<void>;
  }
}

// UUID regex pattern
const UUID_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

window.cleanDTBs = async (dtbIds?: string[]) => {
  console.log('Starting cleanDTBs...');
  if (dtbIds) {
    console.log(`Will only process DTBs with IDs: ${dtbIds.join(', ')}`);
  }
  const orgId = localStorage.getItem('phx-currentOrganizationId');
    if (!orgId) {
      throw new Error('Could not find organizationId in localStorage');
    }
    console.log('Organization ID:', orgId);
  
  try {
    // Get all DTBs with page size of 100
    const response = await getDTBs(orgId,{ status: 'ALL', limit: 100 });
    const dtbs = response.content;

    console.log(`Found ${dtbs.length} DTBs to process`);

    // Process each DTB
    for (const dtb of dtbs) {
      // Skip if dtbIds is provided and this DTB's ID is not in the list
      if (dtbIds && !dtbIds.includes(dtb.id)) {
        console.log(`Skipping DTB ${dtb.id} as it's not in the target list`);
        continue;
      }

      if (UUID_PATTERN.test(dtb.name)) {
        console.log(`Found DTB with UUID in name: ${dtb.name}`);
        
        try {
          if(dtb.lock){
            // Try to take the lock first
            console.log(`Attempting to take lock for DTB ${dtb.id}`);
            await takeDTBLock(orgId, dtb.id);
            await removeDTBLock(orgId, dtb.id);
            console.log(`Successfully took lock for DTB ${dtb.id}`);
          }

          console.log(`Deleting DTB with ID: ${dtb.id}`);
          await deleteDTB(orgId, dtb.id);
          console.log(`Successfully deleted DTB ${dtb.id}`);
        } catch (error) {
          console.error(`Failed to process DTB ${dtb.id}:`, error);
        }
      }
    }

    console.log('cleanDTBs completed successfully!');
  } catch (error) {
    console.error('Error in cleanDTBs:', error);
  }
}; 